/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAgencyCheckAgencyNameGet$Params {
  value?: string;
  guid?: string;
  'api-version'?: string;
}

export function apiAgencyCheckAgencyNameGet(http: HttpClient, rootUrl: string, params?: ApiAgencyCheckAgencyNameGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyCheckAgencyNameGet.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
    rb.query('guid', params.guid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgencyCheckAgencyNameGet.PATH = '/api/agency/check-agency-name';
